/**
 * Task Module
 */
(function (){
    'use strict';
    angular.module('elogbooks.user.master-tasks', []);
})();
